import { useState } from 'react'

import type { Visibility } from '../../00-Primitives/ToolTip'
import IconButton from '../IconButton'
import ToolTip from '../../00-Primitives/ToolTip'
import ShareIcon from 'ui-component-library/icons/link-solid.svg'

type Props = {
  onClick: () => void
  children: string
  tooltipText: string
}

function ShareButton({ onClick, children, tooltipText }: Props) {
  const [toolTipVisibility, setToolTipVisibility] = useState<Visibility>('hide')

  const toggleShareToolTip = () => {
    setToolTipVisibility('show')
    setTimeout(() => {
      setToolTipVisibility('hide')
    }, 2000)
  }

  function handleClick() {
    toggleShareToolTip()
    onClick()
  }

  return (
    <>
      <IconButton Icon={ShareIcon} onClick={handleClick}>
        {children}
      </IconButton>
      <ToolTip visibility={toolTipVisibility}>{tooltipText}</ToolTip>
    </>
  )
}

export default ShareButton
